import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {LineSettingDto} from '../../../../generated-model/models';

@Injectable({providedIn: 'root'})
export class LineSettingService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/settings/line-notification';

  getSetting(): Observable<LineSettingDto> {
    return this.http.get<LineSettingDto>(this.apiUrl);
  }

  saveSetting(dto: LineSettingDto): Observable<LineSettingDto> {
    return this.http.put<LineSettingDto>(this.apiUrl, dto);
  }
}
